<script lang="ts">
    import {createEventDispatcher} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';
    import KpIconButton from 'shared/ui-widgets/button/KpIconButton.svelte';

    export let threadContentPlacement: 'fullscreen-page' | 'popover';

    const dispatch = createEventDispatcher<{'message-sent': string}>();

    let value = '';

    const handleSendMessage = () => {
        if (!exists(value) || !value) {
            return;
        }

        dispatch('message-sent', value);
        value = '';
    };
</script>

<form class="message-composer-bar"
      class:in-fullscreen-page="{threadContentPlacement === 'fullscreen-page'}"
      on:submit|preventDefault={handleSendMessage}>

    <KpIconButton icon="add" disabled/>
    <input class="input-bar" type="text" placeholder="Nová zpráva..." bind:value>
    <KpIconButton icon="paper-plane" on:click={handleSendMessage}/>
</form>

<style lang="less">
    @import (reference) "styles/portaro.variables.less";
    @import (reference) "styles/portaro.themes.less";

    @composer-bar-height: 40px;

    .message-composer-bar {
        position: relative;
        display: flex;
        align-items: center;
        gap: @spacing-sm;

        &.in-fullscreen-page {
            &:before {
                content: '';
                position: absolute;
                bottom: 100%;
                left: 0;
                right: 0;
                height: @spacing-xxl;
                background: linear-gradient(to bottom, transparent, @themed-body-bg);
            }
        }

        .input-bar {
            flex-grow: 1;
            border: 1px solid @themed-border-default;
            border-radius: @border-radius-default;
            padding: 0 @spacing-m;
            height: @composer-bar-height;

            &:focus,
            &:active,
            &:focus-visible {
                outline: none !important; // We don't want default outline outline
            }
        }
    }

    :global {
        .message-composer-bar {
            .kp-icon-button {
                height: @composer-bar-height;
                width: @composer-bar-height;
            }

            &.in-fullscreen-page {
                .kp-icon-button {
                    background-color: @themed-panel-bg;
                }

                .input-bar {
                    background-color: @themed-panel-bg;
                }
            }
        }
    }
</style>